import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import RatingDialog from "@/components/RatingDialog";

export default function PendingRatingsList() {
  const [items, setItems] = useState([]);
  const [direction, setDirection] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/ratings/pending/mine");
      setItems(data.items || []);
      setDirection(data.direction);
    } catch { /* silent */ }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading || items.length === 0) return null;

  const heading = direction === "vendor"
    ? "Rate your vendors from past events"
    : "Rate your past event organizers";

  return (
    <section className="mt-12" data-testid="pending-ratings">
      <div className="overline" style={{ color: "var(--moss)" }}>Post-event feedback</div>
      <div className="mt-1 flex items-baseline justify-between flex-wrap gap-3">
        <h2 className="font-serif text-3xl">{heading}</h2>
        <div className="text-xs" style={{ color: "var(--ink-soft)" }}>
          {items.length} pending · ratings show on their public profile
        </div>
      </div>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {items.map((it) => (
          <div key={it.application_id} className="card-warm rounded-sm p-5" data-testid={`pending-rating-${it.application_id}`}>
            <div className="overline" style={{ color: "var(--terracotta)" }}>
              {it.event_city} · {it.event_date}
            </div>
            <div className="font-serif text-xl mt-1">{it.event_title}</div>
            <div className="mt-1 text-sm" style={{ color: "var(--ink-soft)" }}>
              With <span className="font-medium">{it.counterparty_name}</span>
            </div>
            <div className="mt-4">
              <RatingDialog
                applicationId={it.application_id}
                direction={direction}
                counterpartyName={it.counterparty_name}
                eventTitle={it.event_title}
                onRated={load}
                trigger={
                  <Button
                    data-testid={`rate-btn-${it.application_id}`}
                    className="btn-primary rounded-full inline-flex items-center gap-2"
                  >
                    <Star className="h-4 w-4" /> Leave rating
                  </Button>
                }
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
